<script setup lang="ts">
type WishlistActionProps = {
  id: string
  constructorItemParam: RequiredItemParam
}
const props = defineProps<WishlistActionProps>()
const wishlistStore = useWishlistStore()
const { isInWishlist: checkIsInWishlist, toggleItem } = wishlistStore
const { trackWishlistConversion } = useConstructorTracker()
const { t } = useI18n()
const parentLocation = inject('location', LOCATIONS.content)
const lowercaseLocation = parentLocation?.toLowerCase()

const isInWishlist = computed(() => {
  return checkIsInWishlist(props.id)
})
const label = computed(() => {
  return isInWishlist.value
    ? t('product_details_page.remove_from_wishlist.button.text')
    : t('product_details_page.add_to_wishlist.button.text')
})
const toggleWishlistItem = async () => {
  const addToWishlist = !isInWishlist.value
  await toggleItem(props.id)
  if (addToWishlist) {
    pushEventToDataLayer(
      'custom.ecommerce.wishlist.add',
      buildWishlistPayload(true, wishlistStore.wishlist, [{ id: props.id, quantity: 1 }], lowercaseLocation),
    )
    trackWishlistConversion(props.constructorItemParam)
  } else {
    pushEventToDataLayer(
      'custom.ecommerce.wishlist.remove',
      buildWishlistPayload(false, wishlistStore.wishlist, [{ id: props.id, quantity: 1 }], lowercaseLocation),
    )
  }
}
</script>

<template>
  <button
    class="wishlist-action"
    type="button"
    data-testid="wishlist-action"
    :data-in-wishlist="isInWishlist"
    :data-test-product-id="id"
    :aria-label="label"
    @keyup.enter.stop.prevent="toggleWishlistItem"
    @click.stop.prevent="toggleWishlistItem"
  >
    <svg-icon v-if="isInWishlist" name="mhj:heart-solid" />
    <svg-icon v-else name="mhj:heart-border" />
  </button>
</template>

<style lang="postcss">
.wishlist-action {
  .icons:hover {
    color: var(--text-primary);
  }
}
</style>
